module.exports = __webpack_public_path__ + "static/media/background-BLUE@2x-80.2b47e469.jpg";